import Vue from 'vue';
import Swiper from "vue-awesome-swiper";

import init from '@/pages/entry';
import App from './App.vue';

// fix issue #2184
Vue.use(Swiper);

Vue.config.productionTip = false

init(Vue);

new Vue({
  render: h => h(App),
}).$mount('#app')
